var map = {
	"./0x.png": 1134,
	"./1inch.png": 1135,
	"./CRV-logo.png": 1136,
	"./DAI-logo.png": 1137,
	"./ETH-logo.png": 1138,
	"./USD.svg": 1139,
	"./YFI-logo.png": 1140,
	"./aave.png": 1141,
	"./aavev2.svg": 1142,
	"./abracadabra.svg": 1143,
	"./akropolis.svg": 1144,
	"./alchemix.png": 1145,
	"./alpaca.svg": 1146,
	"./alpha-homora.svg": 1147,
	"./ampleforth.svg": 1148,
	"./anchor.svg": 1149,
	"./argent.png": 1150,
	"./armor-circle-logo.svg": 206,
	"./armor-logo.svg": 1151,
	"./armor.png": 164,
	"./armor_background.jpg": 1152,
	"./arnxm.png": 165,
	"./badger.png": 1153,
	"./badgerdao.png": 1154,
	"./balancer.svg": 1155,
	"./bancor.svg": 1156,
	"./barnbridge.png": 1157,
	"./benchmark-protocol.png": 1158,
	"./binance.png": 1159,
	"./binance.svg": 1160,
	"./blockFi.svg": 1161,
	"./bunnypancake.svg": 1162,
	"./bzx.png": 1163,
	"./celsius.svg": 1164,
	"./centrifuge.svg": 1165,
	"./cofix.jpg": 1166,
	"./coinbase.png": 1167,
	"./coinbaseWalletIcon.svg": 1168,
	"./coinbase_mini.png": 1169,
	"./compoundv2.png": 1170,
	"./convex.png": 1171,
	"./cover.jpg": 1172,
	"./cream.svg": 1173,
	"./cryptocom.svg": 1174,
	"./curve.png": 1175,
	"./dai.png": 1176,
	"./ddex.png": 1177,
	"./deversifi.svg": 1178,
	"./dforce.svg": 1179,
	"./dodo.png": 1180,
	"./dxdao.svg": 1181,
	"./dydx.svg": 1182,
	"./eth.png": 1183,
	"./eth2.jpg": 1184,
	"./flexa.png": 1185,
	"./fonts/WorkSans-VariableFont_wght.ttf": 1186,
	"./fortmaticIcon.png": 1187,
	"./ftx.svg": 1188,
	"./gemini.png": 1189,
	"./gnosis-multisig.svg": 1190,
	"./gnosis_safe.png": 1191,
	"./goldfinch.svg": 1192,
	"./harvest.png": 1193,
	"./hegic.png": 1194,
	"./hero_armor_background.jpg": 381,
	"./hodlnaut.svg": 1195,
	"./icn-aethereum.svg": 1196,
	"./icn-ledger.svg": 1197,
	"./icn-metamask.svg": 1198,
	"./idex.png": 1199,
	"./idle.png": 1200,
	"./iearn.png": 1201,
	"./ill_coming_soon_no_shadow.svg": 382,
	"./inlock.png": 1202,
	"./keeperdao.jpg": 1203,
	"./kraken.svg": 1204,
	"./kyber.png": 1205,
	"./langs/en.svg": 531,
	"./langs/ja.svg": 532,
	"./langs/ko.svg": 533,
	"./langs/ru.svg": 534,
	"./langs/zh.svg": 535,
	"./ledn.svg": 1206,
	"./liquity.png": 1207,
	"./logos/binance.svg": 536,
	"./logos/check_circle.svg": 187,
	"./logos/connect_disconnected.svg": 268,
	"./logos/gas_price.svg": 537,
	"./logos/gift.svg": 538,
	"./logos/lock.svg": 539,
	"./logos/protect.svg": 540,
	"./logos/stats.svg": 541,
	"./makerdao.png": 1208,
	"./melon.png": 1209,
	"./metamask-right.png": 166,
	"./metamask.png": 1210,
	"./metamask.svg": 1211,
	"./moloch.png": 1212,
	"./mooniswap.svg": 1213,
	"./mstable.svg": 1214,
	"./new_armor_background.jpg": 383,
	"./nexo.svg": 1215,
	"./notional.png": 1216,
	"./nucypher.svg": 1217,
	"./nuo.png": 1218,
	"./olympusdao.svg": 1219,
	"./opyn.png": 1220,
	"./originusd.png": 1221,
	"./pancakeswap.svg": 1222,
	"./pangolin.svg": 1223,
	"./paraswap.png": 1224,
	"./perpetual.jpg": 1225,
	"./pooltogether.svg": 1226,
	"./popsicle.svg": 1227,
	"./portisIcon.png": 1228,
	"./premia.svg": 1229,
	"./rari.png": 1230,
	"./reflexer.png": 1231,
	"./ren.svg": 1232,
	"./ribbon.svg": 1233,
	"./saturndao.png": 1234,
	"./squarelink.png": 1235,
	"./stakedao.png": 1236,
	"./sushiswap.jpg": 1237,
	"./synthetix.png": 1238,
	"./synthetix.svg": 1239,
	"./tbtc.svg": 1240,
	"./thorchain.svg": 1241,
	"./tokensets.png": 1242,
	"./tornado.png": 1243,
	"./torus.jpg": 1244,
	"./totle.png": 1245,
	"./trader-joe.svg": 1246,
	"./trezor.png": 1247,
	"./truefi.jpg": 1248,
	"./trustWallet.png": 1249,
	"./uma.png": 1250,
	"./uniswap.png": 1251,
	"./uniswapv2.png": 1252,
	"./uniswapv3.svg": 1253,
	"./venus.svg": 1254,
	"./vesper.jpeg": 1255,
	"./visor.png": 1256,
	"./walletConnectIcon.svg": 1257,
	"./yam.png": 1258,
	"./yearnfinance.png": 1259,
	"./yield.jpg": 1260,
	"./yieldapp.png": 1261
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62;